module.exports = __webpack_public_path__ + "static/media/mk.c93a8993.png";